import React, { useState } from 'react';


const CONTACT_ITEMS = [
  { icon: '📍', t: 'Head Office', info: '1172, Sector 11,\nPanchkula, Haryana — 134109, India' },
  { icon: '📞', t: 'Phone', info: '+91 92161 83238' },
  { icon: '✉️', t: 'Email', info: 'aqmcs@aqmcs.com' },
];

const SOCIALS = [
  {
    label: 'Instagram',
    href: 'https://instagram.com/aqmcs_',
    svg: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
      </svg>
    ),
  },
  {
    label: 'Facebook',
    href: 'https://facebook.com/aqmcs.india',
    svg: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M20 0H4C1.791 0 0 1.791 0 4v16c0 2.209 1.791 4 4 4h16c2.209 0 4-1.791 4-4V4c0-2.209-1.791-4-4-4zm-3 7h-1.5C14.672 7 14 7.672 14 8.5V10h3l-.5 3h-2.5v8h-3v-8H9v-3h2V8.5C11 6.015 12.515 4 15 4c1.036 0 2 .196 2 .196V7z"/>
      </svg>
    ),
  },
  {
    label: 'LinkedIn',
    href: 'https://linkedin.com/company/aqmcs',
    svg: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    ),
  },
  {
    label: 'X (Twitter)',
    href: 'https://x.com/aqmcs',
    svg: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    ),
  },
];

export default function ContactPage({ setPage }) {
  const [form, setForm] = useState({ name: '', company: '', email: '', phone: '', message: '' });
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error

  const handle = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      const res = await fetch('/.netlify/functions/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ formType: 'contact', ...form }),
      });
      const data = await res.json();
      if (data.success) {
        setStatus('success');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <main className="page" id="main-content">
      {/* ── PAGE HERO ── */}
      <header className="page-hero">
        <div className="ph-inner">
          <nav className="breadcrumb" aria-label="Breadcrumb">
            <span onClick={() => { setPage('Home'); window.scrollTo(0, 0); }}>Home</span>
            <span className="sep">/</span>
            <span className="cur">Contact Us</span>
          </nav>
          <h1>Contact/Feedback</h1>
          <p>
            Ready to start your certification journey? Reach out and our experts will
            respond you.
          </p>
        </div>
      </header>

      {/* ── CONTACT GRID ── */}
      <section className="section" aria-labelledby="contact-heading">
        <div className="sec-inner">
          <div className="contact-grid">

            {/* ── LEFT: Info ── */}
            <div>
              <div className="sec-tag">Contact Information</div>
              <p className="sec-lead" style={{ marginBottom: '2.5rem' }}>
                Reach out to discuss certification needs, get a quote.
              </p>

              {CONTACT_ITEMS.map((c, i) => (
                <div key={i} className="ci-item">
                  <div className="ci-icon" aria-hidden="true">{c.icon}</div>
                  <div className="ci-txt">
                    <h4>{c.t}</h4>
                    <p>{c.info}</p>
                  </div>
                </div>
              ))}

              <div>
                <h4 style={{
                  fontSize: '0.78rem',
                  fontWeight: 800,
                  color: 'var(--navy)',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  marginBottom: '1rem',
                }}>
                  Follow Us
                </h4>
                <div className="footer-socials">
                  {SOCIALS.map(({ svg, label, href }) => (
                    <a key={label} className="social-btn" href={href} aria-label={label} title={label} target="_blank" rel="noopener noreferrer">
                      {svg}
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* ── RIGHT: Form ── */}
            <div className="form-card">
              <h3 style={{
                fontFamily: 'Cormorant Garamond, serif',
                fontSize: '1.5rem',
                fontWeight: 700,
                color: 'var(--navy)',
                marginBottom: '0.4rem',
              }}>
                Send Us a Message / Feedback
              </h3>

              {/* ── SUCCESS STATE ── */}
              {status === 'success' ? (
                <div className="fsuccess" role="status" style={{ marginTop: '1.5rem' }}>
                  ✅ Thank you! Our team member will contact you shortly.
                </div>
              ) : (
                /* ── FORM ── */
                <form onSubmit={handleSubmit} noValidate>

                  <div className="form-row2">
                    {/* Full Name */}
                    <div className="fgrp">
                      <label htmlFor="name">Full Name *</label>
                      <input
                        id="name"
                        type="text"
                        name="name"
                        value={form.name}
                        onChange={handle}
                        placeholder="Your Name"
                        required
                      />
                    </div>

                    {/* Company */}
                    <div className="fgrp">
                      <label htmlFor="company">Company Name</label>
                      <input
                        id="company"
                        type="text"
                        name="company"
                        value={form.company}
                        onChange={handle}
                        placeholder="Your Company"
                      />
                    </div>
                  </div>

                  <div className="form-row2">
                    {/* Email */}
                    <div className="fgrp">
                      <label htmlFor="email">Email Address *</label>
                      <input
                        id="email"
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handle}
                        placeholder="name@company.com"
                        required
                      />
                    </div>

                    {/* Phone */}
                    <div className="fgrp">
                      <label htmlFor="phone">Phone Number</label>
                      <input
                        id="phone"
                        type="tel"
                        name="phone"
                        value={form.phone}
                        onChange={handle}
                        placeholder="+91 99999 99999"
                      />
                    </div>
                  </div>

                  {/* Message */}
                  <div className="fgrp">
                    <label htmlFor="message">Your Message</label>
                    <textarea
                      id="message"
                      name="message"
                      value={form.message}
                      onChange={handle}
                      placeholder="Tell us about your requirements, timeline, or any questions..."
                    />
                  </div>

                  {status === 'error' && (
                    <p style={{ color: 'red', fontSize: '0.875rem', marginBottom: '1rem' }}>
                      ⚠️ Something went wrong. Please try again or email us directly.
                    </p>
                  )}

                  <button
                    className="fsub"
                    type="submit"
                    disabled={status === 'submitting'}
                    style={{ opacity: status === 'submitting' ? 0.7 : 1, cursor: status === 'submitting' ? 'not-allowed' : 'pointer' }}
                  >
                    {status === 'submitting' ? 'Sending…' : 'Send Message →'}
                  </button>

                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ── OFFICE BLOCK ── */}
      <div className="office-block">
        <div className="office-card">
          <div className="office-card-inner">
            <div style={{ fontSize: '2.8rem', marginBottom: '1rem' }}>📍</div>
            <h3 style={{
              fontFamily: 'Cormorant Garamond, serif',
              fontSize: '1.6rem', fontWeight: 700,
              color: 'var(--white)', marginBottom: '0.5rem',
            }}>
              
            </h3>
            <p style={{ color: 'rgba(255,255,255,.7)', fontSize: '0.95rem', marginBottom: '0.5rem' }}>
              1172 Sector 11, Panchkula, Haryana — 134109, India
            </p>
            <div className="office-info-grid">
              {[
                { icon: '📞', label: 'Call Us', val: '+91 92161 83238' },
                { icon: '✉️', label: 'Email Us', val: 'aqmcs@aqmcs.com' },
                { icon: '🕐', label: 'Business Hours', val: 'Mon–Sat, 9AM–5:30PM' },
              ].map((item, i) => (
                <div key={i} className="office-info-item">
                  <div className="office-info-emoji">{item.icon}</div>
                  <div className="office-info-label">{item.label}</div>
                  <div className="office-info-value">{item.val}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

    </main>
  );
}
